import { useCirculatingSupply } from '@/api';
import { KpiCard, KpiEntityName, Link, Page, PageSkeleton } from '@/components';
import { useSearchParams } from '@/hooks';
import { tokensMapping } from '@/utils/tokens';
import {
  CryptoIcon,
  Flex,
  Heading,
  LinkWrapper,
  PercentageValue
} from '@blockanalitica/ui';
import HistoricTabs from './HistoricTabs';
import USDSBackedBreakdown from './USDSBacked';

export default function SupplyPage() {
  const [daysAgo] = useSearchParams('days_ago', '1');
  const [data, error] = useCirculatingSupply(daysAgo);

  if (error) {
    throw error;
  }

  if (data) {
    return (
      <Page title={<Heading size="1">Supply</Heading>}>
        <KpiCard
          variant="usds"
          title="Total Supply"
          field="total_circulating"
          data={data}
          options={{
            variants: { kpiCardValue: 'singleTitle' },
            prefixIcon: (
              <KpiEntityName
                symbol2={
                  <CryptoIcon
                    name="DAI"
                    address={tokensMapping('DAI').address}
                    size="4"
                  />
                }
                symbol1={
                  <CryptoIcon
                    name="USDS"
                    address={tokensMapping('USDS').address}
                    size="4"
                  />
                }></KpiEntityName>
            )
          }}
        />

        <HistoricTabs />
        <Flex gap={['m', 's']} flexDirection={['column', 'row']}>
          <LinkWrapper
            to={`/tokens/${tokensMapping('USDS').address}`}
            // @ts-ignore
            as={Link}
            variant="kpiCardLinkWithBlendMode">
            <KpiCard
              title="Total USDS Supply"
              variant="usds"
              data={data}
              field="circulating_usds"
              options={{
                linkArrow: true,
                variants: { kpiCardValue: 'sharedTitle' },
                currency: {
                  name: 'USDS',
                  address: tokensMapping('USDS').address
                }
              }}
              footer={
                <Flex gap="3xs">
                  <PercentageValue
                    value={data.circulating_usds / data.total_circulating}
                  />
                  <span>of total supply</span>
                </Flex>
              }
            />
          </LinkWrapper>
          <LinkWrapper
            to={`/tokens/${tokensMapping('DAI').address}`}
            // @ts-ignore
            as={Link}
            variant="kpiCardLinkWithBlendMode">
            <KpiCard
              title="Total DAI Supply"
              variant="dai"
              data={data}
              field="circulating_dai"
              options={{
                variants: { kpiCardValue: 'sharedTitle' },
                linkArrow: true,
                currency: {
                  name: 'DAI',
                  address: tokensMapping('DAI').address
                }
              }}
              footer={
                <Flex gap="3xs">
                  <PercentageValue
                    value={data.circulating_dai / data.total_circulating}
                  />
                  <span>of total supply</span>
                </Flex>
              }
            />
          </LinkWrapper>
        </Flex>
        <USDSBackedBreakdown />
      </Page>
    );
  }
  return <PageSkeleton />;
}
